import React, { useState } from "react";
import about1 from "../../assets/images/about_service_1.webp";
import aboutusImage1 from "../../assets/images/aboutusImage1.webp";
import { Link } from "react-router-dom";

const Service = () => {
  const [ytshow, setytshow] = useState(false);

  return (
    <>
      <section className="row_am service_section about_service">
        <div className="container">
          <div className="row service_blocks">
            <div className="col-md-6">
              <div
                className="service_text"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="title_badge">
                  <span>Overview</span>
                </div>
                <h2>Latar Belakang Mina Label </h2>
                <p>
                  Kami telah berprofesi di bidang label lebih dari 42 tahun,
                  dengan mesin-mesin yang khusus dan modern dan di operatorkan
                  dengan pekerja-pekerja yang ahli serta pengalaman. Perusahaan
                  kami memproduksi logo woven yang berkualitas, untuk seragam
                  perusahaan, fashion, garment, instansi pemerintah, sekolah dan
                  UMKM. Kami sangat mementingkan kualitas dan detail pada logo
                  anda.
                </p>
                <ul className="feature_list">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Menggunakan alat yang modern</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Bantuan designer dengan pengalaman yang tinggi</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Pelayanan maksimal</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Bahan berkualitas</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="inner_block rotate_left"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div
                  className="img video_player"
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                    overflow: "hidden",
                  }}
                >
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "20px",
                      border: "none",
                    }}
                    src="https://www.youtube.com/embed/XOcz9zUrLm4?autoplay=0&mute=1&loop=1"
                    title="Mina Label Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Service;
